export default "__VITE_ASSET__Bfqltt_e__"